<template>
  <e-dialog
    :dialog-title="dialogTitle"
    :center-dialog-visible="dialogVisible"
    :popup-width="popupWidth"
    :close-btn="closeBtn"
    :destroy-close="true"
    :modal-append-to-body="false"
    :close-model="false"
    :close-on-press-escape="false"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
  >
    <el-form ref="form" :model="applyForm" label-width="100px" class="form">
      <el-form-item label="过程资料：">
        <eui-upload
          ref="euiUploadTwo"
          :file-list="fileArr"
          :action="uploadPayCenterFile"
          :private-upload="privateUpload"
          :headers="headers"
          :show-file-list="true"
          single
          accept=".jpg,.png"
          text="选择文件"
          :picure-width="200"
          @handleSuccess="uploadSuccess"
        ></eui-upload>
      </el-form-item>
      <el-form-item label="其他资料：">
        <eui-upload
          ref="euiUploadTwo"
          :file-list="fileArr"
          :action="uploadPayCenterFile"
          :private-upload="privateUpload"
          :headers="headers"
          :show-file-list="true"
          single
          accept=".jpg,.png"
          text="选择文件"
          :picure-width="200"
          @handleSuccess="uploadSuccess"
        ></eui-upload>
      </el-form-item>
      <el-form-item label="EQE编码：">
        <!-- <el-select v-model="value2" multiple collapse-tags style="margin-left: 20px" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select> -->
      </el-form-item>
      <div>*请下载模版，并按模版要求上传过程资料，支持上传文档、图片、视频、压缩包等，文件大小不能超过1G。</div>
    </el-form>
  </e-dialog>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import api from '@/modules/projectA/api/pay/index';
import { epecToken } from '@/modules/projectA/utils/globalData';

export default {
  components: {
    EDialog,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    applyForm: {
      type: Object,
      default: () => ({
        applyReson: '',
      }),
    },
  },
  data() {
    return {
      dialogTitle: '上传资料',
      closeBtn: true,
      popupWidth: '520px',
      tipsMessage: '20M以内，仅上传一个附件，格式excel、pdf、word、rar、zip',

      fileArr: [],
      uploadPayCenterFile: api.uploadPayCenterFile,
      privateUpload: {
        keyName: 'filePath',
        url: api.getSupplierLicenceUrl,
        method: 'get',
      },
      headers: epecToken,
    };
  },
  methods: {
    uploadSuccess(response, file, fileList) {
      console.log(response, file, fileList, '上传的返回');
    },
    getFileInfo(fileList) {
      const [fileData] = fileList;
      this.applyForm.attachName = fileData.fileName;
      this.applyForm.attachPath = fileData.fileUrl;
    },
    // 关闭弹窗事件
    resetPopupData() {
      this.$emit('update:dialogVisible', false);
    },
    // 提交事件
    async submitPopupData() {
      const { applyReson, attachName, attachPath, filingCompanyId, filingCompanyName, resourceId } = this.applyForm;
      const result = await Api.addFilingApply({
        applyReson,
        attachName,
        attachPath,
        filingCompanyId,
        filingCompanyName,
        filingType: 1,
        resourceId,
      });
      if (result.code === '200') {
        this.resetPopupData();
        this.$message.success('申请成功');
        this.$emit('refresh');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tip {
  color: #f56c6c;
  margin: 0 0 10px 20px;
}
::v-deep .form {
  .el-form-item__content {
    width: auto;
  }
}
</style>
